import React from 'react';

export default function Splash({ message = 'Loading Page' }) {
  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-white/90 tw-z-[9999]">
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-4">
        {/* Spinner */}
        <div className="tw-w-10 tw-h-10 tw-border-4 tw-border-gray-200 tw-border-t-gray-400 tw-rounded-full tw-animate-spin"></div>
        {/* Message */}
        <div className="tw-text-gray-600 tw-text-md tw-font-medium">{message}</div>
      </div>
    </div>
  );
}
